import React, { useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { forgottenPassword as forgottenPasswordFunction } from '../../components/shared/auth/forgotten-password'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router'

const ForgottenPassword = () => {
    const [t] = useTranslation()

    const [email, setEmail] = useState('')
    const [redirect, setRedirect] = useState(false)
    const authError = useSelector(state => state.auth.error)
    const busy = useSelector(state => state.auth.busy)

    const submitForm = event => {
        event.preventDefault()

        forgottenPasswordFunction(email)
            .then(() => setRedirect('/login'))
    }

    return (
        <form onSubmit={submitForm}>
            {redirect && <Redirect to={redirect} />}
            <h2>{t('login.forgottenPassword')}</h2>

            <div className="mb-3 form-floating">
                <input
                    type="email"
                    className="form-control"
                    id="email-input"
                    value={email}
                    onChange={({ target }) => setEmail(target.value)}
                    placeholder={t('login.email')}
                />
                <label htmlFor="email-input">
                    {t('login.email')}
                </label>
            </div>

            {authError && (
                <div className="text-danger">
                    {t(authError)}
                </div>
            )}

            <button
                type="submit"
                className={classNames({
                    'btn btn-primary': true,
                    'disabled': busy,
                })}
            >
                {busy && <i className="fa fa-spinner fa-spin" />}
                {!busy && t('login.submit')}
            </button>
        </form>
    )
}

export default ForgottenPassword
